export const dailyPerformanceData: { date: string; profit: number; sales: number; cost: number; revenue: number }[] = [];

export const weeklyStats = {
  totalProfit: 0,
  totalSales: 0,
  avgROI: 0,
  bestDay: "—",
};

export const flipHistoryData: {
  id: number;
  item: string;
  buyPrice: number;
  sellPrice: number;
  fees: number;
  platform: string;
  date: string;
  profit: number;
  status: string;
}[] = [];

export const platformFees = [
  { platform: "StockX", saleFee: 9.5, paymentFee: 3.0, shipping: 13.95, notes: "Fee drops with higher seller level" },
  { platform: "GOAT", saleFee: 9.5, paymentFee: 2.9, shipping: 12.5, notes: "15% for new sellers (first 3 sales)" },
  { platform: "eBay", saleFee: 12.9, paymentFee: 0, shipping: 0, notes: "Final value fee, free shipping optional" },
  { platform: "Depop", saleFee: 10.0, paymentFee: 2.9, shipping: 0, notes: "PayPal fees apply separately" },
  { platform: "Grailed", saleFee: 9.0, paymentFee: 2.9, shipping: 0, notes: "+$0.30 per transaction" },
  { platform: "Facebook MP", saleFee: 5.0, paymentFee: 0, shipping: 0, notes: "Local pickup = 0% fee" },
  { platform: "Poshmark", saleFee: 20.0, paymentFee: 0, shipping: 0, notes: "$2.95 flat fee for sales under $15" },
  { platform: "Mercari", saleFee: 10.0, paymentFee: 2.9, shipping: 0, notes: "Seller pays processing + 10% flat fee" },
  { platform: "Whatnot", saleFee: 8.0, paymentFee: 0, shipping: 0, notes: "8% commission on final hammer price" },
  { platform: "Amazon", saleFee: 15.0, paymentFee: 0, shipping: 0, notes: "Referral fee varies 8–15% by category" },
  { platform: "OfferUp", saleFee: 12.9, paymentFee: 0, shipping: 0, notes: "12.9% service fee on shipped sales" },
  { platform: "Goldin", saleFee: 10.0, paymentFee: 0, shipping: 0, notes: "Seller commission on final sale price" },
];
